<template>
  <div class="benefit-box">
    <div class="benefit-title" v-if="!noBuy">{{ benefitInfo.title }}</div>
    <div v-for="(item, index) of benefitInfo.content" :key="index" @click="goDetailed(item)">
        <div class="list">
            <div class="left"><img :src="item.iconUrl" alt=""></div>
            <div class="right">
                <div class="main-title" v-if="item.title">
                    <div class="title-desc">{{ item.title }}</div>
                </div>
                <div class="main-title" v-if="item.desc">
                    <div class="minor-title">{{ item.desc }}</div>
                </div>
                <div class="main-title" v-if="!noBuy && item.totalAmount>0">
                    <div class="minor-title">{{ $t('FoodC_birthday_nxQg_feGV',{n:item.availableAmount}) }}</div>
                </div>
                <div class="main-title">
                    <span class="birthday-title" v-if="item.birthday">{{ $t('FoodC_birthday_teJB_YsTQ',{date:item.birthday}) }}</span>
                    <div @click.stop="goSettingBir" v-if="item.receiveStatus === 0" class="setting-bir">{{ $t('FoodC_birthday_MdbO_KlNx') }}</div>
                    <div @click.stop="getBirthdayCoupons" v-if="item.receiveStatus === 1 && !noBuy" class="setting-bir">{{ $t('FoodC_birthday_hJRO_UaMS') }}</div>
                    <div @click.stop="goCoupons" v-if="item.receiveStatus === 3 && !noBuy" class="setting-bir">{{ $t('FoodC_birthday_vcey_tequ') }}</div>
                </div>
            </div>
            <div v-if="item.detailedDesc">
                <i class="right-icon icon-v3_outlined_entrance"></i>
            </div>
        </div>
        <div class="list-box" v-if="index === benefitInfo.content.length-1"></div>
    </div>
  </div>
</template>

<script>
export default {
    props:['benefitInfo', 'noBuy'],
    methods:{
        // 跳转到详情弹窗
        goDetailed(data){
            const {detailedDesc = ""} = data
            if(!detailedDesc){
                return
            }
            this.$emit('handleClick', data)
        },
        // 跳转到设置生日弹窗
        goSettingBir(){
            this.$emit('goSettingBir')
        },
        // 领取生日券
        getBirthdayCoupons(){
            this.$emit('getBirthdayCoupons')
        },
        // 跳转到优惠券中心
        goCoupons(){
            this.$emit('goCoupons')
        }
    }
}
</script>

<style lang="scss" scoped>
.benefit-box{
    background: #fff;
    padding-left: 32px;
    padding-right: 32px;
}
.benefit-title{
    font-family: DiDiSans-Pro-Bold;
    font-size: 36px;
    color: #000000;
    line-height: 36px;
    padding-top: 48px;
    margin-bottom: 24px;
    // word-break: break-all;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2; /* 这里是超出几行省略 */
    overflow: hidden;
}
.list{
    display: flex;
    align-items: center;
    padding: 16px 0;
    margin-bottom: 16px;
    .left {
        img {
            width: 100px;
            height: 100px;
            margin-right: 32px;
        }
    }
    .right {
        flex: 1;
        margin-right: 32px;
        .main-title{
            display: flex;
            .title-desc{
                flex: 1;
                font-family: DiDiSans-Pro-Bold;
                font-size: 32px;
                color: #000000;
                line-height: 40px;
                // word-break: break-all;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2; /* 这里是超出几行省略 */
                overflow: hidden;
            }
            .num{
                font-family: DiDiSans-Pro-Bold;
                font-size: 32px;
                color: #000000;
                line-height: 40px;
                width: 80px;
                text-align: right;
                position: relative;
                span {
                    position: absolute;
                    right: 0;
                    bottom: 0;
                }
            }
        }
       
        .minor-title{
            flex: 1;
            margin-top: 8px;
            opacity: 0.6;
            font-family: DiDiSans-Pro-Regular;
            font-size: 24px;
            color: #000000;
            line-height: 32px;
            // word-break: break-all;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2; /* 这里是超出几行省略 */
            overflow: hidden;
        }
        .setting-bir{
            flex-grow: 1;
            text-decoration-line: underline;
            font-family: DiDiSans-Pro-Bold;
            margin-top: 8px;
            font-size: 24px;
            color: #ff8040;
            line-height: 30px;
            font-weight: 400;
        }
        .birthday-title{
            line-height: 30px;
            white-space:nowrap;
            margin-top: 8px;
            margin-right: 24px;
            opacity: 0.6;
            font-family: DiDiSans-Pro-Regular;
            font-size: 24px;
            color: #000000;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2; /* 这里是超出几行省略 */
            overflow: hidden;
        }
    }
    .right-icon {
        font-size: 24px;
        width: 24px;
        height: 24px;
        opacity: 0.6;
    }
 
}
.list-box{
    height: 32px;
}

</style>